// Shared helpers for legacy WebSocket and Laravel Reverb notification transports.

import { pushNotification } from "../utils/config";
import type { INotificationItem } from "../app/modules/core/_models";
import store from "../redux/store";
import { addNotificationAction } from "../redux/actions/notification.action";

export interface NotificationWsMessage {
    type: "NEW_NOTIFICATION";
    payload: INotificationItem;
}

export function isNotificationWsMessage(data: unknown): data is NotificationWsMessage {
    return (
        typeof data === "object" &&
        data !== null &&
        (data as NotificationWsMessage).type === "NEW_NOTIFICATION" &&
        Boolean((data as NotificationWsMessage).payload)
    );
}

/** Browser toast + Redux bell list — same handling for both WS transports. */
export function handleIncomingNotification(data: unknown): void {
    if (!isNotificationWsMessage(data)) {
        return;
    }

    const { title, message } = data.payload;
    pushNotification(title, {
        body: message,
        icon: "/icon.png",
    });
    store.dispatch(addNotificationAction(data.payload));
}
